window.catalogData = {
  "tyreBrands": [
    "Triangle",
    "Mickey Thompson",
    "Yokohama",
    "Maxxis",
    "Michelin",
    "Pirelli",
    "Cooper",
    "BF Goodrich",
    "Bridgestone",
    "Continental",
    "Kenda",
    "Kumho",
    "Marshal by Kumho",
    "Falken",
    "General",
    "GT Radial",
    "Mastercraft",
    "Nexen",
    "Toyo",
    "Radar",
    "Hankook"
  ],
  "wheelBrands": [
    "PDXX",
    "Dirty Life",
    "R Series",
    "Advanti Racing",
    "American Racing",
    "Asanti Wheels",
    "Enkei",
    "GT Form",
    "JSR Wheels",
    "Lenso",
    "Motegi",
    "Orbit",
    "Petrol",
    "Reproduction Wheels",
    "ROH",
    "Rotiform",
    "Speedy",
    "SpeedWorks",
    "Street Pro",
    "TSW",
    "US Mags",
    "Kansei",
    "CSA Wheels",
    "Konig",
    "Globe",
    "Raceline Wheels",
    "KMC Wheels",
    "Mayhem",
    "Icon Alloys",
    "Moto Metal",
    "Pro Comp",
    "Dynamic Steel Wheels",
    "DWC Wheels",
    "Ion Wheels",
    "XD Wheels",
    "Black Rhino Hard Alloys",
    "Helo",
    "Niche",
    "Ohm",
    "Foose",
    "American Outlaw",
    "Black Rock Offroad"
  ],
  "groups": [
    {
      "category": "Tyres",
      "brand": "Triangle",
      "sourceUrl": "https://triangle-tire.com/",
      "models": [
        "AdvanteX SUV TR259",
        "AdvanteX TC101",
        "AdvanteX TC101 EV",
        "AgileX A/T TR292",
        "AgileX M/T TR281",
        "ConneX Van TV701",
        "EffexSport TH202",
        "EffexSport TH201",
        "Protract TE301",
        "ReliaX Touring TE307",
        "Sportex TH201",
        "TR246",
        "TR257",
        "TR259",
        "TR292",
        "TR652",
        "TR665",
        "TR689A",
        "TR918",
        "TR928"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Mickey Thompson",
      "sourceUrl": "https://www.mickeythompsontires.com/light-truck-tires",
      "models": [
        "Baja Boss A/T",
        "Baja Boss M/T",
        "Baja Legend EXP",
        "Baja Legend MTZ",
        "Baja Legend MTZ Pro",
        "Baja Legend APZ",
        "Baja Pro XS",
        "Baja Pro X",
        "Baja Pro X Competition",
        "Baja Claw TTC",
        "Deegan 38 All-Terrain",
        "Deegan 38 Mud-Terrain",
        "Street Comp",
        "ET Street R",
        "ET Street S/S",
        "ET Street Radial Pro"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Yokohama",
      "sourceUrl": "https://www.yokohama.com.au/",
      "models": [
        "ADVAN Sport V107",
        "ADVAN Sport V105",
        "ADVAN Fleva V701",
        "ADVAN Neova AD09",
        "ADVAN A052",
        "BluEarth-GT AE51",
        "BluEarth AE01",
        "BluEarth ES32",
        "BluEarth RV-02",
        "BluEarth Van RY55",
        "Geolandar A/T G015",
        "Geolandar A/T4 G018",
        "Geolandar X-AT G016",
        "Geolandar M/T G003",
        "Geolandar CV G058",
        "Geolandar H/T G056",
        "Geolandar X-CV G057",
        "Advan dB V552",
        "Avid Ascend GT",
        "iceGUARD iG53"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Maxxis",
      "sourceUrl": "https://maxxistyres.com.au/shop/",
      "models": [
        "Razr AT811",
        "Razr MT772",
        "Razr HT780",
        "Bravo AT771",
        "Bravo AT771 HP",
        "Bravo HT770",
        "Bravo HP-M3",
        "Bravo UE-168",
        "Premitra HP5",
        "Victra Sport VS5",
        "Victra Sport EV",
        "Victra MA-Z4S",
        "Victra MA510",
        "Mecotra ME3",
        "MA-P5",
        "MA-751",
        "MA-589",
        "Mudzilla M8080",
        "Bighorn MT-764",
        "Creepy Crawler M8090"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Michelin",
      "sourceUrl": "https://www.michelin.com.au/auto/browse-tyres/all-tyres",
      "models": [
        "Pilot Sport 5",
        "Pilot Sport 4",
        "Pilot Sport 4 SUV",
        "Pilot Sport 4 S",
        "Pilot Sport Cup 2",
        "Pilot Sport A/S 4",
        "Primacy 5",
        "Primacy 4",
        "Primacy 4+",
        "Primacy SUV+",
        "Primacy Tour A/S",
        "Energy XM2+",
        "e.Primacy",
        "Latitude Sport 3",
        "Latitude Tour HP",
        "LTX Trail",
        "LTX Force",
        "Agilis 3",
        "Agilis CrossClimate",
        "CrossClimate 2"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Pirelli",
      "sourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue",
      "models": [
        "P ZERO",
        "P ZERO (PZ4)",
        "P ZERO (PZ5)",
        "P ZERO E",
        "P ZERO CORSA SYSTEM",
        "P ZERO ROSSO",
        "POWERGY",
        "DRAGON SPORT",
        "CINTURATO P1",
        "CINTURATO P6",
        "CINTURATO P7",
        "CINTURATO P7 (P7C2)",
        "CINTURATO ROSSO",
        "CARRIER",
        "SCORPION ATR",
        "SCORPION STR",
        "SCORPION VERDE",
        "SCORPION VERDE ALL SEASON",
        "SCORPION ZERO",
        "SCORPION ZERO ALL SEASON",
        "SCORPION ZERO ASIMMETRICO",
        "SCORPION ALL TERRAIN PLUS",
        "SCORPION MTR",
        "SCORPION MS"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Cooper",
      "sourceUrl": "https://coopertires.com.au/our-range/",
      "models": [
        "ROAD+TRAIL AT",
        "STRONGHOLD AT",
        "LTZ PRO",
        "RUGGED TREK",
        "STT PRO",
        "AT3 LT",
        "AT3 4S",
        "AT3 XLT",
        "S/T MAXX",
        "ATT",
        "Pro Control",
        "CTT",
        "Discoverer HT3",
        "Discoverer SRX",
        "Evolution C5",
        "Zeon RS3-G1"
      ]
    },
    {
      "category": "Tyres",
      "brand": "BF Goodrich",
      "sourceUrl": "https://www.bfgoodrich.com.au/auto/browse-tyres/all-tyres",
      "models": [
        "All-Terrain T/A KO3",
        "All-Terrain T/A KO2",
        "Trail-Terrain T/A",
        "Mud-Terrain T/A KM3",
        "HD-Terrain T/A KT",
        "g-Force Phenom T/A",
        "g-Force Sport Comp-2",
        "Advantage Control",
        "Radial T/A",
        "Commercial T/A All-Season 2"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Bridgestone",
      "sourceUrl": "https://www.bridgestone.com.au/product",
      "models": [
        "Potenza Sport",
        "Potenza RE-71RS",
        "Potenza Adrenalin RE003",
        "Potenza S007A",
        "Turanza T005",
        "Turanza T005A",
        "Turanza T006",
        "Turanza Serenity Plus",
        "Ecopia EP300",
        "Ecopia H/L 001",
        "Dueler A/T 002",
        "Dueler A/T 697",
        "Dueler H/T 684",
        "Dueler H/P Sport",
        "Dueler M/T 674",
        "Alenza 001",
        "Alenza Sport A/S",
        "Weather Control A005",
        "Duravis R660",
        "Supercat A/T"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Continental",
      "sourceUrl": "https://www.continental-tires.com/au/en/products/",
      "models": [
        "SportContact 7",
        "SportContact 6",
        "PremiumContact 7",
        "PremiumContact 6",
        "EcoContact 6",
        "EcoContact 6 Q",
        "UltraContact",
        "ComfortContact CC7",
        "MaxContact MC7",
        "MaxContact MC6",
        "CrossContact LX25",
        "CrossContact LX Sport",
        "CrossContact ATR",
        "CrossContact H/T",
        "ContiSportContact 5",
        "ContiPremiumContact 5",
        "VanContact Eco",
        "VanContact Ultra",
        "AllSeasonContact",
        "WinterContact TS 870"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Kenda",
      "sourceUrl": "https://www.kendatires.com.au/tyres/offroad",
      "models": [
        "Klever R/T KR601",
        "Klever A/T2 KR628",
        "Klever M/T2 KR629",
        "Klever H/T2 KR600",
        "Komet Plus KR23",
        "Kenetica KR217",
        "Vezda UHP A/S KR400",
        "Vezda Touring A/S KR205",
        "Vezda Eco KR30",
        "Kargo Trail KR500",
        "Karrier KR33",
        "Komendo KR33A"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Kumho",
      "sourceUrl": "https://www.kumho.com.au/home/",
      "models": [
        "Ecsta PS71",
        "Ecsta PA51",
        "Ecsta PS91",
        "Ecsta HS52",
        "Ecsta HS51",
        "Ecsta KU39",
        "Solus TA21",
        "Solus TA31",
        "Solus KH17",
        "Sense KR26",
        "Crugen HP71",
        "Crugen HP91",
        "Crugen HT51",
        "Crugen KL33",
        "Road Venture AT52",
        "Road Venture AT51",
        "Road Venture MT71",
        "Road Venture MT51",
        "PorTran KC53",
        "WinterCraft WP72"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Marshal by Kumho",
      "sourceUrl": "https://www.marshaltyre.com.au/",
      "models": [
        "MH15",
        "MH12",
        "MU12",
        "HP91",
        "KL21",
        "HT51",
        "KL51",
        "AT51",
        "MT51",
        "KC53"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Falken",
      "sourceUrl": "https://www.falken.com.au/category/products/",
      "models": [
        "Wildpeak A/T3W",
        "Wildpeak A/T4W",
        "Wildpeak R/T01",
        "Wildpeak M/T01",
        "Wildpeak H/T02",
        "Wildpeak H/T HT01",
        "Azenis FK520",
        "Azenis FK510",
        "Azenis FK510 SUV",
        "Azenis RT615K+",
        "Azenis RT660",
        "Ziex ZE310 EcoRun",
        "Ziex ZE914 EcoRun",
        "Ziex CT60 A/S",
        "Sincera SN110",
        "Sincera SN832i",
        "Euroall Season AS220 Pro",
        "Linam VAN01",
        "Linam R51",
        "ZIEX S/TZ05"
      ]
    },
    {
      "category": "Tyres",
      "brand": "General",
      "sourceUrl": "https://generaltire.com/",
      "models": [
        "Grabber ATX",
        "Grabber A/TX",
        "Grabber AT3",
        "Grabber APT",
        "Grabber X3",
        "Grabber HTS60",
        "Grabber HTS",
        "Grabber UHP",
        "Grabber GT",
        "Grabber GT Plus",
        "Altimax One",
        "Altimax One S",
        "Altimax RT45",
        "Altimax 365AW",
        "G-MAX RS",
        "G-MAX AS-05"
      ]
    },
    {
      "category": "Tyres",
      "brand": "GT Radial",
      "sourceUrl": "https://gtradial.com.au/tyre-range/",
      "models": [
        "SportActive 2",
        "SportActive",
        "Champiro SX2",
        "Champiro FE2",
        "Champiro VP1",
        "Champiro ECO",
        "FE2 SUV",
        "Savero SUV",
        "Savero HT2",
        "Savero AT Plus",
        "Savero A/T Pro",
        "Savero M/T",
        "Adventuro AT3",
        "Adventuro M/T",
        "Maxmiler Pro",
        "Maxmiler WT2",
        "Maxmiler CX",
        "Komodo M/T Plus",
        "IcePro SUV 3",
        "WinterPro 2"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Mastercraft",
      "sourceUrl": "https://www.mastercrafttires.com/tires",
      "models": [
        "Courser All Weather",
        "Courser CXT",
        "Courser HXT",
        "Courser MXT",
        "Courser Quest",
        "Courser Quest Plus",
        "Courser Trail",
        "Courser Trail HD",
        "Courser Trail RT",
        "Avenger",
        "Avenger G/T",
        "Avenger M8",
        "Glacier MSR",
        "Glacier Trex",
        "SRT Touring",
        "Stratus AP",
        "Stratus AS",
        "Stratus HT"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Nexen",
      "sourceUrl": "https://www.nexentire.com/au/",
      "models": [
        "N'Fera Sport",
        "N'Fera SU1",
        "N'Fera SU4",
        "N'Fera AU7",
        "N'Blue HD Plus",
        "N'Blue 4Season",
        "N'Priz AH8",
        "N'Priz AH5",
        "Roadian ATX",
        "Roadian AT Pro RA8",
        "Roadian MTX",
        "Roadian HTX RH5",
        "Roadian GTX",
        "Roadian HP",
        "Roadian CT8",
        "Winguard Sport 2",
        "Winguard Ice Plus"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Toyo",
      "sourceUrl": "https://www.toyotires.com.au/",
      "models": [
        "Open Country A/T III",
        "Open Country A/T II",
        "Open Country R/T",
        "Open Country M/T",
        "Open Country H/T II",
        "Open Country U/T",
        "Open Country Q/T",
        "Open Country C/T",
        "Proxes Sport",
        "Proxes Sport 2",
        "Proxes Sport SUV",
        "Proxes C1S",
        "Proxes C100 Plus",
        "Proxes CF2",
        "Proxes R888R",
        "Proxes R1R",
        "NanoEnergy 3",
        "NanoEnergy Van",
        "Observe GSi-6",
        "Tranpath MPZ"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Radar",
      "sourceUrl": "https://radartyres.com.au/",
      "models": [
        "Renegade A/T Pro",
        "Renegade R/T+",
        "Renegade R7 M/T",
        "Renegade R5",
        "Renegade R/T",
        "Dimax R8+",
        "Dimax R8",
        "Dimax AS-8",
        "Dimax Classic",
        "Dimax 4 Season",
        "Rivera Pro 2",
        "Rivera Sport",
        "RPX800",
        "RPX10",
        "Argonite RV-4",
        "Argonite Alpine",
        "Angler RST22"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Hankook",
      "sourceUrl": "https://www.hankooktire.com/au/en/home.html",
      "models": [
        "Ventus S1 evo3",
        "Ventus S1 evo3 SUV",
        "Ventus S1 evo Z",
        "Ventus Prime 4",
        "Ventus V12 evo2",
        "Ventus RS4",
        "Dynapro AT2",
        "Dynapro AT2 Xtreme",
        "Dynapro MT2",
        "Dynapro HP2",
        "Dynapro HT",
        "Dynapro HPX",
        "Kinergy Eco2",
        "Kinergy GT",
        "Kinergy 4S2",
        "Optimo K415",
        "Vantra LT",
        "Vantra Trailer",
        "iON evo",
        "iON evo SUV",
        "iON ST AS"
      ]
    },
    {
      "category": "Wheels",
      "brand": "PDXX",
      "sourceUrl": "https://pdxxoffroad.com/collections/all",
      "models": [
        "Control V8",
        "Fury",
        "Rock",
        "Enforcer",
        "Viking",
        "Kito Beadlock",
        "Bush",
        "Conquest",
        "Dominator",
        "Fouder Polar",
        "Hanvock",
        "Rage",
        "Sando",
        "Takedown"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Dirty Life",
      "sourceUrl": "https://www.dirtylifewheels.com/all-wheels",
      "models": [
        "9317 DT-3 Dual-Tek",
        "9303 DT-1 Dual-Tek",
        "9310 Canyon",
        "9309 Canyon Pro",
        "9305 Theory",
        "9306 Mesa",
        "9307 Drifter",
        "9301 Roadkill",
        "9302 Roadkill Race Beadlock",
        "9311 Enigma Pro",
        "9312 Mesa Race",
        "9313 Enigma Race",
        "9314 Canyon Race",
        "9400 Roadkill Forged Beadlock",
        "9318 DT-4 Dual-Tek",
        "9304 DT-2 Dual-Tek",
        "146"
      ]
    },
    {
      "category": "Wheels",
      "brand": "R Series",
      "sourceUrl": "https://rserieswheels.com/collections",
      "models": [
        "SS-Y",
        "GS7 SF",
        "GTSR-M SF",
        "Blade8",
        "LS88",
        "SPORT8 SF",
        "Hammer",
        "Inflex SF",
        "Signature",
        "GTS",
        "VX SF",
        "VF2 R8 SF",
        "VF2",
        "Rapier",
        "Star",
        "WS Max",
        "Wallky WS",
        "MC173 SF",
        "MC177 SF",
        "MC822",
        "MC825",
        "MC877 SF",
        "MC877",
        "BM355",
        "BM358",
        "BM391",
        "PV209",
        "AV108",
        "HD609",
        "HD612",
        "FD919"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Advanti Racing",
      "sourceUrl": "https://www.advantiracingwheels.com/wheel-collection",
      "models": [
        "AXR Alonso 5",
        "AXR Predator 5",
        "AXR Predator 6",
        "M8501",
        "Magnum",
        "MR82",
        "TT11 Titan",
        "Verona",
        "ADR N3135 6GR",
        "Avalanche",
        "Caesar",
        "Everest",
        "Hurricane",
        "M8",
        "Mogul",
        "N676D",
        "Punch",
        "Tourer",
        "Trax",
        "Tungsten",
        "Typhoon"
      ]
    },
    {
      "category": "Wheels",
      "brand": "American Racing",
      "sourceUrl": "https://www.americanracing.com/wheels/all-wheels",
      "models": [
        "VN501 500 Mono Cast",
        "AR23",
        "AR904",
        "AR172 Baja",
        "AR204 Baja Dually",
        "AR 927 Barrage",
        "AR942 Bishop",
        "VN215 Classic Torq Thrust II",
        "VN205 Classic Torq Thrust II Custom",
        "AR924 Crossfire",
        "VN510 Draft",
        "VN516 G-Force",
        "VN514 Groove",
        "AR952 GT Street",
        "VN450 Hopster",
        "AR941 Mach Five",
        "AR893 Mainline",
        "VN517 Marauder",
        "AR61 Outlaw I",
        "AR62 Outlaw II",
        "AR172 Satin Black",
        "VN605 Torq Thrust D",
        "VN105 Torq Thrust D",
        "VN309 Torq Thrust Original",
        "VN427 Shelby Cobra",
        "AR105 Torq Thrust M",
        "AR200 Yukon",
        "AR201",
        "AR605 Torq Thrust M",
        "AR708",
        "AR890",
        "AR910",
        "AR916",
        "AR920 Blockhead",
        "AR932 Splitter",
        "AR933 Intake",
        "AR934 Fastlane",
        "AR955 Stampede",
        "TTF",
        "VN109 TT 0",
        "VN407 Cobra",
        "VN47 Vector",
        "VN511 Salt Flat",
        "VN515 Torq Thrust II 1 PC",
        "VN69 Ansen Sprint"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Asanti Wheels",
      "sourceUrl": "https://www.asantiwheels.com/products/wheels",
      "models": [
        "Black Label ABL-23 Sigma",
        "AB814 Windmill",
        "ABL31 Regal"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Enkei",
      "sourceUrl": "https://enkei.com/wheels/",
      "models": [
        "RPF1",
        "GTC02",
        "RS05RR",
        "PF07",
        "PF09",
        "RPT1",
        "FC01",
        "Katana",
        "SC46",
        "SC48",
        "SC49",
        "SC50",
        "SC51",
        "SP98",
        "XC02",
        "PFM1",
        "RCT4"
      ]
    },
    {
      "category": "Wheels",
      "brand": "GT Form",
      "sourceUrl": "https://www.gtformwheels.com/",
      "models": [
        "Anvil",
        "Shadow",
        "Legacy",
        "Marquee",
        "Venom",
        "Interflow",
        "Torque",
        "Hearts",
        "HF1.1",
        "HF2.1",
        "HF4.1",
        "LSR",
        "Venus",
        "Voss",
        "Hearts SUV",
        "Radium",
        "Redox",
        "Sena",
        "Vertex",
        "GFS2",
        "GFS3",
        "GFS10",
        "GFS4",
        "GFS5",
        "GFS6",
        "GFS7",
        "GFS8",
        "GFS9"
      ]
    },
    {
      "category": "Wheels",
      "brand": "JSR Wheels",
      "sourceUrl": "https://jsrwheels.com/wheels/",
      "models": [
        "ST06",
        "ST10",
        "ST15",
        "ST19",
        "ST21",
        "ST23",
        "ST24",
        "ST32",
        "ST35",
        "ST37",
        "ST52",
        "ST29",
        "ST26",
        "ST25",
        "ST57"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Lenso",
      "sourceUrl": "https://lensowheels.com.au/collections/all-wheels",
      "models": [
        "KAOS",
        "AMADA",
        "D-1SF",
        "V1N",
        "D-1R",
        "DINERO",
        "CARTEL",
        "D1R-EVO",
        "BSX",
        "90-Z",
        "D-1FC",
        "SPEC-E",
        "D-1SE",
        "Marvel",
        "Argo",
        "M-79",
        "Hurricane",
        "Gravel"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Motegi",
      "sourceUrl": "https://www.motegiwheels.com/products/wheels/all-wheels",
      "models": [
        "MR154 Battle",
        "MR159 Battle V",
        "MR160 Battle VI",
        "MR147 CM7",
        "MR127 CS10",
        "MR143 CS6",
        "MR142 CS8",
        "MR116 FS5",
        "MR161 Kojin",
        "MR131 Traklite",
        "MR118 MS7",
        "MR139 RF11",
        "MR145 Traklite 3.0",
        "MR151 CS5",
        "MR153 CM10",
        "MR140 SS10",
        "MR150 Traklite",
        "MR158 Tsubaki"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Orbit",
      "sourceUrl": "https://www.jaxtyres.com.au/wheels/orbit",
      "models": [
        "Casa",
        "Fitti",
        "Venator",
        "Lotus",
        "Monza",
        "Compact",
        "Form",
        "Rocky",
        "Spider"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Petrol",
      "sourceUrl": "https://www.petrolwheels.com/",
      "models": [
        "P4B",
        "P5C",
        "P4C",
        "PE001 P1D",
        "PE001 P1E",
        "PE003 P2E",
        "PE004 P3E"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Reproduction Wheels",
      "sourceUrl": "https://www.reproductionwheels.com.au/",
      "models": [
        "Boss 335 GT Dark Argent Machined Replica Wheels",
        "E2 Series GTS SV Performance Replica Wheels",
        "E3 Series SV Performance Replica Wheels",
        "F6 BF Typhoon Dark Argent Replica Wheels",
        "Gen-F GTS Blade Replica Wheels",
        "Gen-F SV Rimfire Replica Wheels",
        "Gen-F2 Clubsport R8 Replica Wheels",
        "Gen-F2 GTSR Panorama Replica Wheels",
        "Gen-F2 SV Rapier Replica Wheels",
        "HSV VL Group A SS Walkinshaw Replica Wheels",
        "Irmscher VC VH Retro Replica Wheels",
        "Jeep Grand Cherokee SRT8 WK2 Spider Monkey Replica Wheels",
        "LS3 E Series Pentagon Replica Wheels",
        "Supersports Replica Wheels",
        "VK VE Group A Aero Directional Replica Wheels",
        "Volkswagen Golf GTI Pretoria Replica Wheels",
        "VS GTSR Tri Spoke Replica Wheels",
        "VX GTS Shadow Replica Wheels",
        "VY GTS Hammerhead Replica Wheels",
        "VY Senator Signature Replica Wheels",
        "Boss 335 GT Forged Replica Wheels",
        "F6 Typhoon BF Forged Replica Wheels",
        "Ford Mustang Bullitt Steve McQueen Edition Forged Replica Wheels",
        "Ford Mustang Shelby GT350 Signature Edition Replica Wheels",
        "Ford Mustang Shelby GT500 Track Edition Replica Wheels",
        "Momo Status Forged Replica Wheels",
        "Nissan Skyline R35 GTR HF5 Forged Style Wheel",
        "VN Group A SS SV Forged Replica Wheels",
        "VX Grange Forged Replica Wheels",
        "VZ GTO Coupe Forged Replica Wheels",
        "VZ Senator Prestige Forged Replica Wheels"
      ]
    },
    {
      "category": "Wheels",
      "brand": "ROH",
      "sourceUrl": "https://roh.com.au/",
      "models": [
        "Assault",
        "Blak Trak",
        "Hammer",
        "Raid",
        "Vapour",
        "Zullo",
        "Zullo 5",
        "Arc",
        "Lotus",
        "Apollo",
        "BL01",
        "Raid 5",
        "Crawler",
        "Onyx",
        "Axe",
        "Torque",
        "One Twenty",
        "Pursuit",
        "Rf3",
        "RF4",
        "RF7",
        "Monaco",
        "Forza",
        "Trak D Locker",
        "Track D",
        "Trak 2",
        "Retro"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Rotiform",
      "sourceUrl": "https://www.rotiform.com/products/wheels",
      "models": [
        "ZMO-M",
        "LSE",
        "BPU",
        "RPS",
        "LTN-J",
        "BLQ",
        "BTL",
        "R160 BUC-M",
        "DTM",
        "FLG",
        "KPS",
        "LAS-R",
        "NUE",
        "RSE",
        "SGN",
        "SIX",
        "STL",
        "TUF-R",
        "SPF",
        "JDR",
        "ZMO",
        "KB1",
        "LTN",
        "TUF",
        "KPR",
        "GRZ",
        "CGN",
        "CJJ",
        "ZBF"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Speedy",
      "sourceUrl": "https://speedywheels.com.au/wheels",
      "models": [
        "Alpha",
        "Assault",
        "Axe",
        "Beast",
        "Bedrock",
        "Bronco",
        "Chaos",
        "Cobra",
        "Combat",
        "Dart",
        "Drifter",
        "Grande 2",
        "Havoc",
        "Hotwire",
        "Interceptor",
        "Matterhorn",
        "Outlaw",
        "Rhino",
        "Sandstorm",
        "Savage",
        "Territory",
        "Wasteland",
        "Allure",
        "Badger",
        "Carbine",
        "Cheetah",
        "Cobalt RS",
        "Deceit",
        "Hammer",
        "Hotshot",
        "Impala",
        "Liberator",
        "Monaco",
        "Panther",
        "Podium",
        "Redback",
        "Rewind",
        "Sonic",
        "Stinger",
        "Track",
        "Desert Rat",
        "Swamp Rat"
      ]
    },
    {
      "category": "Wheels",
      "brand": "SpeedWorks",
      "sourceUrl": "https://www.speedworks.com.au/collections/alloy-wheels",
      "models": [
        "SW01",
        "SW02",
        "SW03",
        "SW04",
        "SW05",
        "SW06",
        "SW07",
        "SW08",
        "SW09",
        "SW10",
        "SW11",
        "SW12",
        "SW13",
        "SW14",
        "SW15",
        "SW16",
        "SW17",
        "SW18",
        "SW19",
        "SW20",
        "SW21",
        "SW22",
        "SW23",
        "WS MAX 20",
        "SWF01",
        "SWF02",
        "SWF03",
        "SWF04",
        "SWF05",
        "SWF06",
        "SWF07",
        "SWF08",
        "SWF09",
        "SWF10",
        "SWF11",
        "SWF12",
        "SWF20",
        "Forge-Fit 001 - Mercedes S-Class W222",
        "Forge-Fit 002 - Mercedes S-Class W222",
        "Forge-Fit 003 - Audi R8 Type 4S",
        "Forge-Fit 004 - BMW X4 M F98/G02"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Street Pro",
      "sourceUrl": "https://www.streetprowheels.com.au/wheels",
      "models": [
        "007 Series",
        "009 Series",
        "Street Pro Convo Pro",
        "Street Pro II Convo Pro",
        "Street Pro II V Convo Pro"
      ]
    },
    {
      "category": "Wheels",
      "brand": "TSW",
      "sourceUrl": "https://www.tsw.com/wheels/all-wheels",
      "models": [
        "Bathurst",
        "TW004 Canard",
        "Clypse",
        "TW001 Daytona",
        "TW005 Goodwood",
        "Imatra",
        "TW002 Lasarthe",
        "Launch",
        "Neptune",
        "Sebring",
        "Sector",
        "TW008 Slipstream",
        "Aileron",
        "Ascent",
        "Chapelle",
        "Chrono",
        "Donington",
        "Geneva",
        "Nurburgring"
      ]
    },
    {
      "category": "Wheels",
      "brand": "US Mags",
      "sourceUrl": "https://www.us-mags.com/",
      "models": [
        "1 Piece Bullet U130",
        "1 Piece Rambler U111",
        "1 Piece Indy U101",
        "1 Piece Standard U102",
        "1 Piece Bandit U109",
        "U116 Hustler",
        "U120 Roadster",
        "U129 CTEN",
        "U132 Desperado",
        "U138 Santa Cruz",
        "UC143 Scottsdale",
        "UC147 Flagstaff"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Kansei",
      "sourceUrl": "https://kanseiwheels.com/",
      "models": [
        "KNP",
        "Tandem",
        "Roku",
        "Astro",
        "Corsa",
        "Neo",
        "Seven"
      ]
    },
    {
      "category": "Wheels",
      "brand": "CSA Wheels",
      "sourceUrl": "https://csawheels.com.au/catalogue/",
      "models": [
        "Commando",
        "Hawk",
        "Jackal",
        "Militant",
        "Monster",
        "Outlaw",
        "Predator",
        "Raptor",
        "Renegade",
        "Ridgeline",
        "Savanna",
        "Titan",
        "Thor",
        "Onyx",
        "Thunder",
        "Razorback",
        "Horizon",
        "Sandstorm",
        "Traction",
        "Kinetic",
        "Wrath",
        "Recoil",
        "Attack",
        "Dune",
        "Bullet",
        "RT Pro",
        "Magnum II",
        "Bathurst Trailer",
        "Ranger",
        "Ranger AT D Hole",
        "Ranger AT Round Hole",
        "Ranger MT D Hole",
        "Ranger MT Round Hole",
        "Monaco",
        "Maranello",
        "Vertigo GT",
        "Hotwire",
        "Hornet",
        "Milan",
        "Beretta",
        "Chicane",
        "Vorst",
        "Nitrous",
        "Edge",
        "Bathurst Globe"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Konig",
      "sourceUrl": "https://konigwheels.com/collections/wheels",
      "models": [
        "Hypergram",
        "Dekagram",
        "Ampliform",
        "Rennform",
        "Countergram",
        "Oversteer",
        "Ultragram"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Globe",
      "sourceUrl": "https://www.globewheels.com.au/",
      "models": [
        "Bathurst"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Raceline Wheels",
      "sourceUrl": "https://racelinewheels.com/pages/catalog",
      "models": [
        "A14 Alpha",
        "934 Clutch",
        "935 Defender",
        "950 Gauge",
        "940 Hostage",
        "G77 Mamba",
        "RT232 Monster",
        "947 Scout Van",
        "956 Compass",
        "937 Combat",
        "RT291 Ryno RT",
        "958 Rogue",
        "144 Storm",
        "942 Addict",
        "957 Halo",
        "A12 Squad",
        "A94 Krank",
        "156 Surge Van",
        "953 Krank",
        "952 Aero",
        "A91 Ryno",
        "951 Ryno",
        "949 7X",
        "451 Ryno TR",
        "RT231 Monster",
        "935 Defender Van",
        "928 Monster",
        "159 Spike"
      ]
    },
    {
      "category": "Wheels",
      "brand": "KMC Wheels",
      "sourceUrl": "https://www.kmcwheels.com/wheels",
      "models": [
        "KM241 Blackout",
        "KM556 Crux",
        "KM555 Attack",
        "KM733 Impact FFT",
        "KM732 Archer",
        "KM239 Impact Beadlock",
        "KM553 Torx",
        "KM554 Aztec",
        "KM708 Bully",
        "KM717 Bully OL",
        "KM719 Canyon",
        "KM547 Carnage",
        "KM548 Chase",
        "KM541 Dirty Harry",
        "KM522 Enduro",
        "KM235 Grenade Crawl Beadlock",
        "KM234 Grenade Desert Beadlock",
        "KM549 GRS",
        "KM730 Hatchet",
        "KM542 Impact",
        "KM445 Impact Forged Beadlock",
        "KM447 Impact Forged Monoblock",
        "KM724 Impact OL",
        "KM552 IMS",
        "KM535 Grenade OR",
        "KM540 Recon",
        "KM544 Mesa",
        "KM545 Trek",
        "KM550 Riot SBL",
        "KM100 Sync",
        "KM101 Tempo",
        "KM102 Signal",
        "KM236 Tank Beadlock",
        "KM237 Riot Beadlock",
        "KM238 VI Beadlock",
        "KM444 Mesa Beadlock",
        "KM446 Mesa Forged Monoblock",
        "KM450 Mesa Forged Beadlock",
        "KM451 Mesa Forged Monoblock",
        "KM539 Portal",
        "KM729 Range",
        "KM551 Outrun",
        "KM651 Slide",
        "KM677 D2",
        "KM681 Nerve",
        "KM690 MC 5",
        "KM702 Deuce",
        "KM703 Monophonic",
        "KM706 Impact",
        "KM707 Channel",
        "KM709 Flux",
        "KM710 Takedown",
        "KM711 Prism",
        "KM712 Prism Truck",
        "KM715 Reverb",
        "KM716 Nomad",
        "KM718 Summit",
        "KM722 Technic",
        "KM723 Trail",
        "KM725 Terra",
        "KM727 Wrath",
        "KM728 Lobo"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Mayhem",
      "sourceUrl": "https://www.mayhemwheels.com/",
      "models": [
        "Cogent",
        "Cogent Dually",
        "Convoy",
        "Horizon",
        "Intrepid",
        "Ridgeline",
        "Vanquish",
        "Cyclone"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Icon Alloys",
      "sourceUrl": "https://iconvehicledynamics.com/collections/wheels",
      "models": [
        "Compression",
        "Rebound",
        "Rebound Pro",
        "Recon Pro",
        "Recon SLX",
        "Vector 6"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Moto Metal",
      "sourceUrl": "https://www.motometal.com/wheels",
      "models": [
        "MO985 Breakout",
        "MO811 Combat",
        "MO992 Folsom",
        "MO998 Kraken",
        "MO810 Legacy",
        "MO970",
        "MO978 Razor",
        "MO986 Siege",
        "MO808 Sniper",
        "MO809 Stinger",
        "MO812 Turbine",
        "MO813 Mason",
        "MO962",
        "MO963",
        "MO966",
        "MO977 Link",
        "MO982 AMP",
        "MO983 Dagger",
        "MO984 Shift",
        "MO993 Hydra"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Pro Comp",
      "sourceUrl": "https://www.procompusa.com/category/wheels/",
      "models": [
        "PA206 Snare",
        "PA205 Wraith",
        "PA201 Heritage",
        "PA202 Basecamp",
        "PA200 Pulse",
        "PA32 Bandido",
        "PA69 Vintage",
        "PA34 Rockwell"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Dynamic Steel Wheels",
      "sourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/",
      "models": [
        "Sunraysia Imitation Beadlock",
        "Sunraysia Genuine Beadlock",
        "Sunraysia",
        "Soft 8 Imitation Beadlock",
        "Soft 8",
        "Smoothie",
        "Slotted",
        "Round Imitation Beadlock",
        "Round HL Mine Spec",
        "Round Genuine Beadlock",
        "Round",
        "OEM Plus",
        "Interceptor",
        "Drift D",
        "D Shape Imitation Beadlock",
        "D Shape Genuine Beadlock",
        "D Shape",
        "Drift Soft 8"
      ]
    },
    {
      "category": "Wheels",
      "brand": "DWC Wheels",
      "sourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/",
      "models": [
        "Sentinel",
        "Convict",
        "Legend",
        "DWC79",
        "Brutal",
        "Lockup",
        "DWC92",
        "666 Devil"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Ion Wheels",
      "sourceUrl": "https://www.ionalloy.com/",
      "models": [
        "143",
        "171",
        "193",
        "14-V6",
        "14-V5",
        "134",
        "20",
        "71"
      ]
    },
    {
      "category": "Wheels",
      "brand": "XD Wheels",
      "sourceUrl": "https://www.xdwheels.com/wheels",
      "models": [
        "XD870 Bomber",
        "XD825 Buck 25",
        "XD137 FMJ",
        "XD852 Gauntlet",
        "XD829 Hoss II",
        "XD778 Monster",
        "XD822 Monster 2",
        "XD851 Monster 3",
        "XD856 Omega",
        "XD860 Onslaught",
        "XD847 Outbreak",
        "XD136 Panzer",
        "XD869 R.O.F.",
        "XD854 Reactor",
        "XD775 Rockstar",
        "XD803 Thump",
        "XD820 Grenade",
        "XD827 Rockstar III",
        "XD129 Holeshot",
        "XD131 RG1",
        "XD139 Portal",
        "XD231 RG Race Beadlock",
        "XD795 Hoss",
        "XD798 Addict",
        "XD811 Rockstar II",
        "XD818 Heist",
        "XD824 Bones",
        "XD835 Swipe",
        "XD837 Demodog",
        "XD838 Mammoth",
        "XD839 Clamp",
        "XD840 Spy II",
        "XD842 Snare",
        "XD844 Pike",
        "XD857 Whiplash",
        "XD859 Gunner",
        "XD861 Storm",
        "XD863",
        "XD865 Phoenix",
        "XD871 Slash"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Black Rhino Hard Alloys",
      "sourceUrl": "",
      "models": [
        "Aliso",
        "Alpha",
        "Alston",
        "Arches",
        "Ark",
        "Armory",
        "Arsenal",
        "Arsenal AT",
        "Atlas",
        "Avenger Beadlock",
        "Baker",
        "Barrage",
        "Barricade",
        "Barstow",
        "Boxer",
        "BR012 Outback",
        "BR014 Sahara",
        "BR015 Voll",
        "BR016 Tusk",
        "BR017 Etosha",
        "BR018 Voyager",
        "BR020 Diamondback",
        "BR021 Mondo",
        "BR022 Bahari",
        "BR023 Explorer",
        "BR024 Awol",
        "BR025 Rival",
        "BR026 Congo",
        "BR028 Guard",
        "BR029 Trooper",
        "BR030 Taleo",
        "BR031 Sol",
        "BR034 Graz",
        "BR035 Kuma",
        "BR036 Basin",
        "BR037 Tembo",
        "BR038 Ronin",
        "Calico",
        "Chamber",
        "Convoy",
        "Crawler",
        "Dugger",
        "Excursion",
        "Fuji",
        "Glamis",
        "Guide",
        "Kelso",
        "Legion",
        "Overland",
        "Ozark",
        "Primm",
        "Primm Beadlock",
        "Raid",
        "Rapid",
        "Reno",
        "Sentinel",
        "Sequoia",
        "Shogun",
        "Shredder",
        "Solid",
        "Stadium",
        "Wanaka",
        "Warlord",
        "Yellowstone",
        "York",
        "Zion"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Helo",
      "sourceUrl": "",
      "models": [
        "HE835",
        "HE844",
        "HE875",
        "HE879",
        "HE885",
        "HE887",
        "HE900",
        "HE901",
        "HE904",
        "HE909",
        "HE914",
        "HE916",
        "HE917",
        "HE918"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Niche",
      "sourceUrl": "",
      "models": [
        "M116 Misano",
        "M135 Milan",
        "M147 Essen",
        "M150 Verona",
        "M182 Staccato"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Ohm",
      "sourceUrl": "",
      "models": [
        "Proton",
        "Lightning"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Foose",
      "sourceUrl": "",
      "models": [
        "F097 Knuckle",
        "F104 Legend"
      ]
    },
    {
      "category": "Wheels",
      "brand": "American Outlaw",
      "sourceUrl": "",
      "models": [
        "Spike R",
        "Spike",
        "Railcar 6",
        "Cord",
        "Capone",
        "Sidewinder",
        "Locker",
        "Legacy",
        "Gunslinger"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Black Rock Offroad",
      "sourceUrl": "",
      "models": [
        "Rambler",
        "Cage",
        "Fury",
        "Vortex",
        "Cobra",
        "Prime",
        "Spider",
        "Bolt",
        "Grip",
        "Anthem",
        "Empire",
        "Forcer",
        "Havoc",
        "Invader",
        "Gunner",
        "FFT01",
        "Mayhem",
        "Piston",
        "Military",
        "Lightning",
        "Hex",
        "Omega",
        "Predator",
        "Stryker",
        "Viper",
        "Summit",
        "Venture",
        "Cargo",
        "Cobra 5S",
        "Duty"
      ]
    },
    {
      "category": "Accessories",
      "brand": "110 Garage",
      "sourceUrl": "",
      "models": [
        "Wheel Nuts",
        "Valve Caps",
        "Centre Caps",
        "TPMS Kits"
      ]
    }
  ]
};
